var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 174,
    viewBox: "0 0 232 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.7 57.3V74.6C215.7 75.7 214.8 76.6 213.7 76.6H30.5V88.7H213.7C214.8 88.7 215.7 89.6 215.7 90.7V151.6H227.8V57.3H215.7Z",
    fill: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 98.4001H59C57.9 98.4001 57 97.5 57 96.4001V57.3H44.8V96.4001C44.8 97.5 43.9 98.4001 42.8 98.4001H18.2C17.1 98.4001 16.2 97.5 16.2 96.4001V57.3H4V104.5C4 107.8 6.7 110.6 10.1 110.6H42.8C43.9 110.6 44.8 111.5 44.8 112.6V151.7H57V112.6C57 111.5 57.9 110.6 59 110.6H94.5V98.4001Z",
    fill: "#0175EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 4C6.8 4 4 6.8 4 10.1V57.3H16.1V18.2C16.1 17.1 17 16.2 18.1 16.2H42.7C43.8 16.2 44.7 17.1 44.7 18.2V57.3H57V18.2C57 17.1 57.9 16.2 59 16.2H132.1C133.2 16.2 134.1 17.1 134.1 18.2V57.3H146.2V18.2C146.2 17.1 147.1 16.2 148.2 16.2H172.8C173.9 16.2 174.8 17.1 174.8 18.2V57.3H187V18.2C187 17.1 187.9 16.2 189 16.2H213.6C214.7 16.2 215.6 17.1 215.6 18.2V57.3H227.7V10.1C227.7 6.8 225 4 221.6 4H10.1Z",
    fill: "#CDCDCD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92 19.2V1C92 0.4 92.5 0 93 0H96C96.6 0 97 0.5 97 1V19.2C97 19.8 96.5 20.2 96 20.2H93C92.4 20.2 92 19.7 92 19.2Z",
    fill: "#FFB7C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3 98.3999H59V110.5H91.3V98.3999Z",
    fill: "url(#paint0_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 59.8H1C0.4 59.8 0 59.3 0 58.8V55.8C0 55.2 0.5 54.8 1 54.8H19.2C19.8 54.8 20.2 55.3 20.2 55.8V58.8C20.2 59.3 19.7 59.8 19.2 59.8Z",
    fill: "#FFB7C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0008 59.8H41.8008C41.2008 59.8 40.8008 59.3 40.8008 58.8V55.8C40.8008 55.2 41.3008 54.8 41.8008 54.8H60.0008C60.6008 54.8 61.0008 55.3 61.0008 55.8V58.8C61.0008 59.3 60.5008 59.8 60.0008 59.8Z",
    fill: "#FFB7C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0008 154.1H41.8008C41.2008 154.1 40.8008 153.6 40.8008 153.1V150.1C40.8008 149.5 41.3008 149.1 41.8008 149.1H60.0008C60.6008 149.1 61.0008 149.6 61.0008 150.1V153.1C61.0008 153.7 60.5008 154.1 60.0008 154.1Z",
    fill: "#FFB7C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.9 57.2999V96.4C174.9 97.5 174 98.4 172.9 98.4H148.3C147.2 98.4 146.3 97.5 146.3 96.4V57.2999H134.2V98.4H124C122.9 98.4 122 97.5 122 96.4V60.7999C122 57.4999 119.3 54.7 115.9 54.7H75.1C71.8 54.7 69 57.3999 69 60.7999V148.1C69 151.4 71.7 154.2 75.1 154.2H115.9C119.2 154.2 122 151.5 122 148.1V112.5C122 111.4 122.9 110.5 124 110.5H172.9C174 110.5 174.9 111.4 174.9 112.5V151.6H187V57.2999H174.9ZM107.8 142H83.2C82.1 142 81.2 141.1 81.2 140V68.9C81.2 67.8 82.1 66.9 83.2 66.9H107.8C108.9 66.9 109.8 67.8 109.8 68.9V140C109.9 141.1 109 142 107.8 142Z",
    fill: "#0175EC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M92 113.5V95.3999C92 94.7999 92.5 94.3999 93 94.3999H96C96.6 94.3999 97 94.8999 97 95.3999V113.6C97 114.2 96.5 114.6 96 114.6H93C92.4 114.5 92 114.1 92 113.5Z",
    fill: "#FFB7C4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M92 69.9V51.7C92 51.1 92.5 50.7 93 50.7H96C96.6 50.7 97 51.2 97 51.7V69.9C97 70.5 96.5 70.9 96 70.9H93C92.4 70.9 92 70.5 92 69.9Z",
    fill: "#FFB7C4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92 157.2V139C92 138.4 92.5 138 93 138H96C96.6 138 97 138.5 97 139V157.2C97 157.8 96.5 158.2 96 158.2H93C92.4 158.2 92 157.7 92 157.2Z",
    fill: "#FFB7C4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149.3 59.8H131.1C130.5 59.8 130.1 59.3 130.1 58.8V55.8C130.1 55.2 130.6 54.8 131.1 54.8H149.3C149.9 54.8 150.3 55.3 150.3 55.8V58.8C150.3 59.3 149.8 59.8 149.3 59.8Z",
    fill: "#FFB7C4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M190.1 59.8H171.9C171.3 59.8 170.9 59.3 170.9 58.8V55.8C170.9 55.2 171.4 54.8 171.9 54.8H190.1C190.7 54.8 191.1 55.3 191.1 55.8V58.8C191.1 59.3 190.6 59.8 190.1 59.8Z",
    fill: "#FFB7C4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M190.1 154.1H171.9C171.3 154.1 170.9 153.6 170.9 153.1V150.1C170.9 149.5 171.4 149.1 171.9 149.1H190.1C190.7 149.1 191.1 149.6 191.1 150.1V153.1C191.1 153.7 190.6 154.1 190.1 154.1Z",
    fill: "#FFB7C4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M230.8 154.1H212.6C212 154.1 211.6 153.6 211.6 153.1V150.1C211.6 149.5 212.1 149.1 212.6 149.1H230.8C231.4 149.1 231.8 149.6 231.8 150.1V153.1C231.9 153.7 231.4 154.1 230.8 154.1Z",
    fill: "#FFB7C4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M230.8 59.8H212.6C212 59.8 211.6 59.3 211.6 58.8V55.8C211.6 55.2 212.1 54.8 212.6 54.8H230.8C231.4 54.8 231.8 55.3 231.8 55.8V58.8C231.9 59.3 231.4 59.8 230.8 59.8Z",
    fill: "#FFB7C4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M134.1 104.4V98.3H123.9V110.4H140.2C136.8 110.5 134.1 107.8 134.1 104.4Z",
    fill: "url(#paint1_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.001 167.6C187.001 170.9 184.301 173.7 180.901 173.7C177.601 173.7 174.801 171 174.801 167.6C174.801 162.4 180.901 156.8 180.901 156.8C180.901 156.8 187.001 162.5 187.001 167.6Z",
    fill: "#FF849A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28 91.7V73.5C28 72.9 28.5 72.5 29 72.5H32C32.6 72.5 33 73 33 73.5V91.7C33 92.3 32.5 92.7 32 92.7H29C28.4 92.7 28 92.3 28 91.7Z",
    fill: "#FFB7C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 58.9736,
    y1: 104.441,
    x2: 91.2905,
    y2: 104.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 8.07343e-8,
    stopColor: "#0175EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0832536,
    stopColor: "#0171E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#0165CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3894,
    stopColor: "#0051A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#004386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6106,
    stopColor: "#0051A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#0165CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9167,
    stopColor: "#0171E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0175EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 123.859,
    y1: 104.441,
    x2: 140.165,
    y2: 104.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 8.07343e-8,
    stopColor: "#0175EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1665,
    stopColor: "#0171E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4381,
    stopColor: "#0165CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7789,
    stopColor: "#0051A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004386"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.815df02a.svg";
export { ForwardRef as ReactComponent };